const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '高清秒播',
    desc: '全网领先的视频播放技术，1080P 高清画质，加载速度快，全程不卡顿不缓冲，为你带来极致流畅的追剧体验。',
  },
  {
    icon: 'ri-stack-line',
    title: '全集收录',
    desc: '5000+ 电视剧全集资源，覆盖国产剧、韩剧、日剧等热门类型，热门剧集全集一次性上线，无需等待分集更新。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '久久影视平台无弹窗广告、无恶意跳转，纯净观影环境让你的追剧时光不受打扰，安心享受每一部好剧。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '电脑、手机、平板三端完美适配，观看记录多设备同步。支持离线缓存和倍速播放，随时随地畅享追剧乐趣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台优势</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            为什么 800 万剧迷选择久久影视看电视剧全集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((item, i) => {
            const iconColors = [
              'bg-primary-100 text-primary-500',
              'bg-accent-100 text-accent-500',
              'bg-secondary-100 text-secondary-500',
              'bg-primary-100 text-primary-500',
            ];
            return (
              <div
                key={item.title}
                className="flex flex-col items-center text-center p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
              >
                <div className={`w-14 h-14 flex items-center justify-center rounded-full ${iconColors[i]} mb-4`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-foreground-900 text-base mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}